import React from 'react';
import { I18nextProvider, translate } from 'react-i18next';
import {
  Router, Route, IndexRoute, browserHistory,
} from 'react-router';

import i18n from '../i18n';

import 'stores/LoginStore';
import App from 'components/App.js';
import LoginView from 'components/LoginView.js';
import WorkspaceView from 'components/WorkspaceView.js';
import ScheduleView from 'components/ScheduleView.js';
import AccountView from 'components/AccountView.js';
import TimeSheetsView from 'components/timesheets/TimeSheetsView.js';
import SelfScheduleView from 'components/SelfScheduleView.js';
import OfflineUnavailableView from 'components/OfflineUnavailableView';

// HOC that renders OfflineUnavailableView instead of the wrapped component
// when the app is offline, avoiding copy-pasting this logic into every view.
function requireOnline(WrappedComponent) {
  class OnlineRoute extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isOnline: Utils.isOnline() };
      this._onOnline = this._onOnline.bind(this);
      this._onOffline = this._onOffline.bind(this);
    }

    _onOnline() { this.setState({ isOnline: true }); }
    _onOffline() { this.setState({ isOnline: false }); }

    componentDidMount() {
      OfflineStore.on('app:online', this._onOnline);
      OfflineStore.on('app:offline', this._onOffline);
    }

    componentWillUnmount() {
      OfflineStore.off('app:online', this._onOnline);
      OfflineStore.off('app:offline', this._onOffline);
    }

    render() {
      if (!this.state.isOnline) return <OfflineUnavailableView />;
      return <WrappedComponent {...this.props} />;
    }
  }
  return OnlineRoute;
}

const NotFound = translate()((props) => (
  <section id="404">
    <h1>{props.t('Routes.404')}</h1>
  </section>
));

function onEnterRoute(obj, replace) {
  const token = Utils.getAuthToken();

  if (token !== null && obj.location.pathname === '/') {
    replace({
      pathname: Utils.getPreviousLocation() == '' ? '/schedule' : Utils.getPreviousLocation(),
      state: { nextPathname: obj.location.pathname },
    });

    return;
  }

  // Block /workspace route on subdomain — user cannot switch workspace
  if (obj.location.pathname === '/workspace' && Utils.isWorkspaceSubdomain()) {
    replace({ pathname: '/' });
    return;
  }

  Utils.setInitialLocation(obj.location.pathname);
  switch (obj.location.pathname) {
    case '/':
      document.querySelector('body').className = 'employee-login';
      break;
    case '/workspace':
      document.querySelector('body').className = 'employee-workspace';
      break;
    case '/schedule':
    default:
      document.querySelector('body').className = '';
  }
}

export default () => (
  <I18nextProvider i18n={i18n}>
    <Router history={Utils.getBrowserHistory()}>
      <Route path="/" component={App} onEnter={onEnterRoute}>
        <IndexRoute store={LoginStore} baseApp={App} component={LoginView} onEnter={onEnterRoute} />
        <Route path="workspace" component={WorkspaceView} onEnter={onEnterRoute} />
        <Route path="schedule(/shifts/:id)" component={ScheduleView} onEnter={onEnterRoute} />
        <Route path="self-schedule(/blocks/:id)" component={requireOnline(SelfScheduleView)} onEnter={onEnterRoute} />
        <Route path="account" component={requireOnline(AccountView)} onEnter={onEnterRoute} />
        <Route path="timesheets" component={requireOnline(TimeSheetsView)} onEnter={onEnterRoute} />
        <Route path="*" component={NotFound} onEnter={onEnterRoute} />
      </Route>
    </Router>
  </I18nextProvider>
);
